const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const CLICK_ID_KEYS = ['gclid', 'fbclid', 'msclkid', 'ttclid', 'wbraid', 'gbraid'];

/**
 * JSON string for Amplitude user property "Attribution Parameters" (UTM, referrer, click ids).
 *
 * HTTP referrer: uses `document.referrer` (set only when the user opened this page via a link
 * from another site). Direct loads, bookmarks, and typed URLs leave it empty — Amplitude SDK
 * `referring_domain` behaves the same. Query params `ref` and `referrer` are not the HTTP
 * Referer header; we still copy them into ReferrerParameters for campaigns that append them.
 *
 * @param {string} search - `window.location.search`
 * @param {string} [referrer] - `document.referrer`
 * @returns {string|null}
 */
export const buildAttributionParametersJson = (search, referrer = '') => {
  const params = new URLSearchParams(search || '');
  const UTMParameters = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) {
      UTMParameters[k] = v;
    }
  });
  const ClickIdParameters = {};
  CLICK_ID_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) {
      ClickIdParameters[k] = v;
    }
  });

  const ReferrerParameters = {};
  const trimmedReferrer = typeof referrer === 'string' ? referrer.trim() : '';
  if (trimmedReferrer) {
    ReferrerParameters.referrer = trimmedReferrer;
    try {
      const u = new URL(trimmedReferrer);
      ReferrerParameters.referring_domain = u.hostname;
    } catch {
      /* non-URL referrer strings ignored */
    }
  }
  const refParam = params.get('ref');
  if (refParam) {
    ReferrerParameters.ref = refParam;
  }
  const referrerQueryParam = params.get('referrer');
  if (referrerQueryParam) {
    ReferrerParameters.referrer_from_query = referrerQueryParam;
  }

  if (
    !Object.keys(UTMParameters).length
    && !Object.keys(ClickIdParameters).length
    && !Object.keys(ReferrerParameters).length
  ) {
    return null;
  }

  return JSON.stringify({
    UTMParameters,
    ClickIdParameters,
    ReferrerParameters,
  });
};
